<template>
  <div ref="printBoxsticker" style="width: 100%;margin: 0 auto;" v-if="isprint">
<div v-for="row in printdata" style="position:relative;width: 321px;height: 311px">
  <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;">
    <tr>
        <td style="width: 50%;vertical-align: top">
          <template v-for="len in row.left">
            <div style="float: left;width: 100%;line-height: 18px;font-size: 9pt;padding-left: 5px;min-height: 28px"  v-if="len['名称']">{{len['名称']}}</div>
            <div v-else style="float: left;width: 100%">
              <div style="float: left;width: 75%;font-size: 17px;line-height: 28px;">&nbsp;&nbsp;<b>{{len['球镜']}}/{{len['柱镜']}}</b></div>
              <div style="float: right;width: 25%;text-align: right;font-size: 17px;line-height: 28px"><b>{{len['数量']}}</b>&nbsp;</div>
            </div>
          </template>
        </td>
        <td style="width: 50%;vertical-align: top">
          <template v-for="len in row.right">
            <div style="float: left;width: 100%;line-height: 18px;font-size: 9pt;padding-left: 5px;min-height: 28px"  v-if="len['名称']">{{len['名称']}}</div>
            <div v-else style="float: left;width: 100%">
              <div style="float: left;width: 75%;font-size: 17px;line-height: 28px">&nbsp;&nbsp;<b>{{len['球镜']}}/{{len['柱镜']}}</b></div>
              <div style="float: right;width: 25%;text-align: right;font-size: 17px;line-height: 28px"><b>{{len['数量']}}</b>&nbsp;</div>
            </div>
          </template>
        </td>
    </tr>
  </table>
  <div style="position: absolute;bottom: 0px;width:100%;border-top-color: black;border-top:1px solid #000000">
    <div style="float: left;width:30%;font-size: 9pt;line-height: 24px">&nbsp;{{row.datastr}}</div>
    <div style="float: left;width:35%;line-height: 24px">合计<span style="padding-right: 30px;padding-left: 5px;font-size: 17px"><b>{{row.totalnumber}}</b></span>片</div>
    <div style="float: left;width:35%;text-align: center;font-size: 9pt;line-height: 24px">盒号:{{row.boxindex}}/{{row.boxmax}}&nbsp;&nbsp;{{row.pageindex}}/{{row.pagemax}}</div>
  </div>
  <P style='page-break-after:always'>&nbsp;</P>
</div>
  </div>
</template>

<script>
    export default {
      name: "Boxsticker",
      data() {
        return {
          printdata: [],
          isprint:false,
        }
      },
      methods: {
        sortProducts(products) {
          return products.sort((a, b) => {
            if (a["产品名称"] !== b["产品名称"]) return b["产品名称"].localeCompare(a["产品名称"]);

            const sphereA = parseFloat(a.球镜);
            const sphereB = parseFloat(b.球镜);
            const cylinderA = parseFloat(a.柱镜);
            const cylinderB = parseFloat(b.柱镜);

            // 1. 先分组：球镜>0的排前面
            if (sphereA > 0 && sphereB <= 0) return -1;
            if (sphereA <= 0 && sphereB > 0) return 1;

            // 2. 同组内先按柱镜从小到大排序
            if (cylinderA !== cylinderB) {
              return cylinderB -cylinderA ;
            }

            // 3. 柱镜相同时，按球镜排序
            if (sphereA > 0) {
              // 正数组：球镜从小到大
              return sphereA - sphereB;
            } else {
              // 非正数组：球镜从大到小
              return sphereB - sphereA;
            }
          });
        },
        print(goods) {
          var newGoods = this.sortProducts(JSON.parse(JSON.stringify(goods)));
          var boxIndex = 0;//第几盒
          var boxlist = [];
          while (true) {
            boxIndex += 1;
            var maxLens = 60;//最大可以装60片
            var pagesize = 1;//总页数
            var pagelimit = 1;//每页记录数
            var lens = [];
            var seedname = '';
            for (let i in newGoods) {
              var lensnumber = parseFloat(newGoods[i]["数量"]);
              if (lensnumber <= 0) continue;

              var boxnum = parseFloat(60 / this.getBoxCapacity(goods[i]));//计算这个光度，每盒可以装几片
              if (boxnum * lensnumber > maxLens) {//数量超标了，需要拆分片数
                lensnumber = Math.trunc(maxLens / boxnum);//最多可装几片（需要向下取值）
              }
              if (lensnumber >= 1) {
                if (seedname == '') seedname = newGoods[i]["产品名称"];
                if (pagelimit == 1 || seedname != newGoods[i]["产品名称"]) {//加载第二个产品
                  if (pagelimit == 18) {//到一页的最后一行，换产品了，就不再加载
                    pagelimit = 1;
                    pagesize += 1;
                    break;
                  }
                  lens.push({
                    "名称": newGoods[i]["产品名称"],
                    "pagesize": pagesize
                  })
                  pagelimit += 1;
                }
                lens.push({
                  "球镜": this.getXY(newGoods[i]["球镜"]),
                  "柱镜": this.getXY(newGoods[i]["柱镜"]),
                  "数量": lensnumber,
                  "pagesize": pagesize
                })
                pagelimit += 1;

                maxLens -= lensnumber * boxnum;
                newGoods[i]["数量"] = parseFloat(newGoods[i]["数量"]) - lensnumber;

                if (pagelimit == 19) {
                  pagelimit = 1;
                  pagesize += 1;
                }

                //老花和近视要分开
                if((newGoods.length-1)>i) {
                  if (parseFloat(newGoods[i]["球镜"]) > 0 && parseFloat(newGoods[parseInt(i) + 1]["球镜"]) <= 0) {
                    break;
                  }
                }
              } else {
                break;//不能再塞进去镜片了，跳出
              }
            }
            if (lens.length == 0) {//取不到镜片了，跳出
              break;
            }
            if (pagelimit == 1) {
              pagesize -= 1;
            }
            boxlist.push({index: boxIndex, pagesize: pagesize, lens: lens});
          }

          var data = new Date();
          var datastr = data.getFullYear() + "-" + this.padString2(data.getMonth() + 1) + "-" + this.padString2(data.getDate());

          var boxprintlist = [];
          for (let i in boxlist) {
            for (let j = 1; j <= boxlist[i].pagesize; j++) {
              var adults = boxlist[i].lens.filter(u => u.pagesize==j);
              var leftData=[];
              var rightData=[];
              var totalnumber=0;
              for(let m in adults) {
                totalnumber += adults[m]["数量"] ? parseInt(adults[m]["数量"]) : 0;
                if(m<9){
                  leftData.push(adults[m]);
                }else{
                  rightData.push(adults[m]);
                }
              }

              var row = {
                datastr: datastr,
                totalnumber: totalnumber,
                boxindex: parseInt(i) + 1,
                boxmax: boxlist.length,
                pageindex: j,
                pagemax: boxlist[i].pagesize,
                left:leftData,
                right:rightData
              };
              boxprintlist.push(row);
            }
          }
          this.printdata=boxprintlist;
          this.isprint = true
          this.$nextTick(() => {
            this.$print(this.$refs.printBoxsticker)
            this.isprint = false
          });

        }, padString2(str) {
          if (str < 10) return '0' + str;
          return str;
        },
        getXY(num) {
          if (num == '0.00') return '-0.00';
          if (num.indexOf('-') == -1 && num.indexOf('+') == -1) return '+' + num;
          return num;
        },
        getBoxCapacity(row) {
          var power = parseFloat((parseFloat(row["球镜"]) + parseFloat(row["柱镜"])).toFixed(2));
          if (power == -0.00) {
            return 60;
          } else if (power >= -1.00 && power >= -0.25) { // -0.25~-1.00（注意范围是从高到低）
            return 56;
          } else if (power >= -2.00 && power >= -1.25) { // -1.25~-2.00
            return 52;
          } else if (power >= -2.75 && power >= -2.25) { // -2.25~-2.75
            return 48;
          } else if (power >= -3.75 && power >= -3.00) { // -3.00~-3.75
            return 40;
          } else if (power >= -4.50 && power >= -4.00) { // -4.00~-4.50
            return 36;
          } else if (power >= -5.50 && power >= -4.75) { // -4.75~-5.50
            return 32;
          } else if (power >= -6.75 && power >= -5.75) { // -5.75~-6.75
            return 28;
          } else if (power >= -8.00 && power >= -7.00) { // -7.00~-8.00
            return 24;
          } else if (power >= -11.00 && power >= -8.25) { // -8.25~-11.00
            return 20;
          } else if (power >= -14.00 && power >= -11.25) { // -11.25~-14.00
            return 16;
          } else if (power <= -14.25) { // -14.25以上
            return 14;
          } else if (power >= 0.25 && power <= 0.50) { // +0.25~+0.50
            return 60;
          } else if (power >= 0.75 && power <= 3.00) { // +0.75~+3.00
            return 56;
          } else if (power >= 3.25 && power <= 4.25) { // +3.25~+4.25
            return 48;
          } else if (power >= 4.50 && power <= 5.00) { // +4.50~+5.00
            return 42;
          } else if (power >= 5.25 && power <= 6.00) { // +5.25~+6.00
            return 38;
          } else if (power >= 6.25 && power <= 8.00) { // +6.25~+8.00
            return 30;
          } else
            return 30;
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/Boxsticker.vue